module.exports = __webpack_public_path__ + "img/operate_icon_4.7bde8c77.png";